module.exports = __webpack_public_path__ + "media/Images/man-smiling-outside-b4a03ca287e9b9d36c8da48b5712d4d0.jpg";